import 'formstone/dist/js/core.js';
import 'formstone/dist/js/background.js';
import 'formstone/dist/js/checkpoint.js';
// import 'formstone/dist/js/equalize.js';
import 'formstone/dist/js/mediaquery.js';
import 'formstone/dist/js/navigation.js';
import 'formstone/dist/js/swap.js';
import 'formstone/dist/js/transition.js';

import './includes/scroll-counter.js';
import './includes/scroll-to.js';

(($) => {

  Formstone.Ready(() => {

    //

    $.mediaquery({
      minWidth: [ 740, 980 ]
    });

    // Tables

    $('.page_content').find('table').wrap('<div class="table_wrapper"><div class="table_wrapper_inner"></div></div>');

    // Load

    let windowTimer = null;

    $(window).on('load', () => {
      if (typeof windowTimer !== null) {
        clearTimeout(windowTimer);
      }

      windowTimer = setTimeout('window.windowResize', 50);
    });

    window.windowResize = () => {
      $(window).trigger('resize');
      $('.js-checkpoint, [data-checkpoint-animation]').checkpoint('resize');
    };

    // Scroll

    let newScroll = -1;
    let lastScroll = 0;

    function onScroll() {
      newScroll = $(window).scrollTop();
    }

    function onRAF() {
      if (newScroll != lastScroll) {

        if (newScroll > 0) {
          $('body').addClass('scrolled');
        } else {
          $('body').removeClass('scrolled');
        }

        lastScroll = newScroll;
      }

      window.requestAnimationFrame(onRAF);
    }

    $(window).on('scroll', onScroll);
    window.requestAnimationFrame(onRAF);

    onScroll();

    // // Desktop Nav

    // $('.js-header_menu_handles li, .js-header_menu').on('mouseenter', (e) {
    //   let id = $(this).attr('id')
    //               .replace('menu-item-', '')
    //               .replace('header_menu-', '');

    //   closeMenus();
    //   openMenu(id);
    // }).on('mouseleave', function() {
    //   closeMenus();

    //   // let id = $(this).attr('id')
    //   //             .replace('menu-item-', '')
    //   //             .replace('header_menu-', '');

    //   // closeMenu(id);
    // });

    // // $('#header_menu-50').addClass('open');

    // function openMenu(id) {
    //   let $handle = $('#menu-item-' + id);
    //   let $menu = $('.js-header_menu-' + id);

    //   $handle.addClass('open');
    //   $menu.addClass('open');
    // }

    // function closeMenus() {
    //   $('.js-header_menu_handles li, .js-header_menu').removeClass('open');
    // }

    // // function closeMenu(id) {
    // //   let $handle = $('#menu-item-' + id);
    // //   let $menu = $('.js-header_menu-' + id);

    // //   $handle.removeClass('open');
    // //   $menu.removeClass('open');
    // // }

    // Mobile Nav

    $('.js-nav_handle').on('activate.swap', (e) => {
      let offset = $('#alert').outerHeight() + 1;

      if (newScroll < offset) {
        window.scrollToPosition(offset);
      }
    });

    $('body').on('click', (e) => {
      if (!$(e.target).closest('.header').length) {
        $('.js-nav_handle').swap('deactivate');
      }
    });

    $('.nav_tray .menu > .menu-item-has-children > a').each((index, el) => {
      let $link = $(el);
      let active = ($link.parent('li').hasClass('current-menu-ancestor') || $link.parent('li').hasClass('current_page_item'));
      let html = '';
      let linkClass = 'js-nav_toggle_' + index;

      html += '<span class="toggle_handle js-swap';
      if (active) {
        linkClass += ' fs-swap-active';
        html += ' fs-swap-active';
      }
      html += '" data-swap-target=".js-nav_toggle_' + index + '"';
      if (active) {
        html += ' data-swap-active="true"';
      }
      html += ' data-swap-options="{&quot;maxWidth&quot;:&quot;979px&quot;}"';
      html += '></span>';

      $link.append(html).next('ul').addClass(linkClass);
    });

    // Filters

    // $('.js-filters select').on('change', (e) => {
    //   $(e.currentTarget).parents('form').submit();
    //   // let url = $(e.currentTarget).val();
    //   // window.location.href = url;
    // });

    // $('.js-jump_link').on('change', (e) => {
    //   let id = $(e.currentTarget).val();
    //   let $to = $(id);

    //   if ($to.length) {
    //     window.scrollToElement(id);
    //   }
    // });


    $('.js-filters .js-filter_link').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      let $link = $(e.currentTarget);
      let filter = $link.data('filter');
      let value = $link.data('value');

      $('#' + filter).val(value).trigger('change');
    });

    $('.js-filters select').on('change', (e) => {
      $(e.currentTarget).parents('form').submit();
      // let url = $(this).val();
      // window.location.href = url;
    });

    $('.js-jump_link').on('change', (e) => {
      let id = $(e.currentTarget).val();
      let $to = $(id);

      if ($to.length) {
        window.scrollToElement(id);
      }
    });

    // Video Media

    function initYouTube() {
      $('.js-video_modal, .js-video_swap').each((index, el) => {
        let $target = $(el);
        let $iframe = $target.find('.js-video_player');
        let src = $iframe.attr('src');

        if (typeof src == 'undefined') {
          $iframe.attr('src', $iframe.data('src'));
        }

        let id = $iframe.attr('id');
        let player = new YT.Player(id, {
          playerVars: {
            'playsinline': 1
          },
          // events: {
          //   'onReady': function(e) {
          //     // e.target.playVideo();
          //   },
          //   // 'onStateChange': onPlayerStateChange
          // }
        });

        $target.data('youtubePlayer', player);
      });
    }

    if ($('.js-video_modal, .js-video_swap').length > 0 && $('script[src*="youtube.com/iframe_api"]').length == 0) {
      $('head').append('<script src="//www.youtube.com/iframe_api"></script>');
    }

    let originalYouTubeCallback = window.onYouTubeIframeAPIReady || null; // Fixes background race condition

    window.onYouTubeIframeAPIReady = () => {
      if (typeof originalYouTubeCallback == 'function') {
        originalYouTubeCallback();
      }

      initYouTube();
    }

    $('.js-video_modal_close, .js-video_swap_close').on('activate.swap', (e) => {
      let $target = $(e.currentTarget).parents('.js-video_modal, .js-video_swap');
      let player = $target.data('youtubePlayer');

      if (typeof player !== 'undefined' && typeof player.playVideo !== 'undefined') {
        player.playVideo();

        let mqState = $.mediaquery('state');

        if (mqState.minWidth < 740) {
          document.documentElement.requestFullscreen();
        }
      }
    }).on('deactivate.swap', (e) => {
      let $target = $(e.currentTarget).parents('.js-video_modal, .js-video_swap');
      let player = $target.data('youtubePlayer');

      if (typeof player !== 'undefined' && typeof player.pauseVideo !== 'undefined') {
        player.pauseVideo();

        if (document.fullscreenElement != null) {
          document.exitFullscreen();
        }
      }
    });

    // Click-close

    $('.js-swap_modal').on('click', (e) => {
      if ($(e.target).hasClass('js-swap_modal')) {
        $(e.target).find('.js-swap').swap('deactivate');
      }
    }).on('activate.swap', function(e) {
      let $this = $(e.target);

      setTimeout(() => {
        $this.find('.js-carousel').carousel('reset');
      }, 170);
    });


    // Scroll Down

    $('.js-scroll_next').on('click', function(e) {
      var $parent = $(e.currentTarget).parents('.js-scroll_next_parent');

      window.scrollToElement($parent.next());
    });


    // Plugins

    $('.js-background').background();
    // $('.js-equalize').equalize();
    $('.js-navigation').navigation();
    $('.js-swap').swap({
        collapse: false,
    });

    $('.js-checkpoint, [data-checkpoint-animation]').checkpoint({
      offset: 100,
      reverse: true
    });

  });

})(jQuery);